import React from 'react'
import '../scss/HomePage.scss'


export default function HomePage() {
  return (
    <h1 className='home-h1'>Welcome!</h1>
  )
}